import noFoundCards from "assets/images/brand/no-results.svg";
import "./index.scss";

export const GroupedDiscountListEmpty = () => {
  return (
    <section className="grouped-discount-list-empty">
      <p>
        <b>Sorry, no results found.</b>
      </p>
      <p>No matching cards. Adjust your filters to see more results.</p>
      <img
        src={noFoundCards}
        alt="No results found"
        height={223}
        width={222}
        className="no-found-results-image"
      />
    </section>
  );
};
